<template>
    <a
        id="mini-cart"
        @click="toggleMiniCart"
        :class="
            `nav-link pl-2 pr-1 mx-1 py-3 my-n2`
        "
    >
            <i class="fa fa-shopping-cart"></i>
            <span class="badge" v-text="itemCount" v-if="itemCount !== 0"></span>
    </a>
</template>

<script>
export default {
    props: ['itemCount', 'cartText'],

    methods: {
        toggleMiniCart: function() {
            let modal = $('#cart-modal-content')[0];

            if (modal) modal.classList.toggle('hide');

            let accountModal = $('.account-modal')[0];

            if (accountModal) accountModal.classList.add('hide');

            event.stopPropagation();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/Resources/assets/js/UI/components/mini-cart-button.vue